import React from "react";

const VARIANTS = {
  hard: { className: "grain", filter: "grainHard" },
  soft: { className: "grain-soft", filter: "grainSoft" },
  paper: { className: "grain-mult", filter: "grainPaper" },
};

// Textura de ruído sobre uma seção. Depende dos filtros de <GrainFilters /> estarem na página.
const Grain = ({ variant }) => {
  const { className, filter } = VARIANTS[variant];

  return (
    <div className={className} aria-hidden="true">
      <svg preserveAspectRatio="none">
        <rect width="100%" height="100%" filter={`url(#${filter})`} />
      </svg>
    </div>
  );
};

// Renderizado uma vez por página.
export const GrainFilters = () => (
  <svg className="grain-defs" aria-hidden="true">
    <filter id="grainHard">
      <feTurbulence type="fractalNoise" baseFrequency="1.1" numOctaves="1" stitchTiles="stitch" />
      <feComponentTransfer>
        <feFuncR type="linear" slope="3.4" intercept="-1.2" />
        <feFuncG type="linear" slope="3.4" intercept="-1.2" />
        <feFuncB type="linear" slope="3.4" intercept="-1.2" />
      </feComponentTransfer>
    </filter>
    <filter id="grainSoft">
      <feTurbulence type="fractalNoise" baseFrequency="0.35" numOctaves="2" stitchTiles="stitch" />
    </filter>
    <filter id="grainPaper">
      <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="1" stitchTiles="stitch" />
      <feComponentTransfer>
        <feFuncR type="linear" slope="1.6" intercept="-0.3" />
        <feFuncG type="linear" slope="1.6" intercept="-0.3" />
        <feFuncB type="linear" slope="1.6" intercept="-0.3" />
      </feComponentTransfer>
    </filter>
  </svg>
);

export default Grain;
